import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnDestroy
} from "@angular/core";

import { OverlayRef, OverlayService } from "@lantern/app/core";
import {
  AnchorPositionStrategy,
  PositionOption
} from "@lantern/app/core/utils/overlays/position-strategies";
import { Status } from "@lantern/app/models";

import {
  TOOLTIP_MESSAGE,
  TOOLTIP_STATUS,
  TooltipComponent,
  TooltipMessage
} from "./tooltip.component";

@Directive({
  selector: "[taTooltipStatic]"
})
export class TooltipStaticDirective implements OnDestroy {
  @Input()
  get taTooltipStatic(): TooltipMessage | undefined {
    return this.message;
  }
  set taTooltipStatic(value: TooltipMessage | undefined) {
    this._message = value;

    if (value == null) {
      this.hideTooltip();
    }
  }

  @Input()
  get tooltipShouldShow(): boolean {
    return this._shouldShow;
  }
  set tooltipShouldShow(value: boolean) {
    this._shouldShow = value;

    if (!this._shouldShow) {
      this.hideTooltip();
    }
  }
  private _shouldShow: boolean = true;

  @Input()
  tooltipPositionOptions: PositionOption[] = ["top", "bottom", "right", "left"];

  @Input()
  tooltipStatus: Status | "" = "";

  get message(): TooltipMessage | undefined {
    return this._message;
  }
  protected _message: TooltipMessage | undefined;

  @HostListener("mouseenter", ["$event"])
  onMouseEnter(): void {
    this.showTooltip();
  }

  @HostListener("mouseleave", ["$event"])
  @HostListener("window:resize", ["$event"])
  onMouseLeave(): void {
    this.hideTooltip();
  }

  constructor(
    private elementRef: ElementRef,
    private overlayService: OverlayService
  ) {}

  ngOnDestroy(): void {
    this.hideTooltip();
  }

  private tooltipPositionStrategy: AnchorPositionStrategy;
  private tooltipOverlayRef?: OverlayRef;
  protected showTooltip(): void {
    if (!this._shouldShow) {
      return;
    }

    // don't show tooltip if it already exists, or tooltip msg is undefined
    if (this.tooltipOverlayRef != null || this.message == null) {
      return;
    }

    if (this.tooltipPositionStrategy == null) {
      this.tooltipPositionStrategy = new AnchorPositionStrategy(
        this.elementRef.nativeElement,
        this.tooltipPositionOptions,
        8
      );
    }

    this.tooltipOverlayRef = this.overlayService.createComponent(
      TooltipComponent,
      this.tooltipPositionStrategy,
      undefined,
      [
        {
          provide: TOOLTIP_MESSAGE,
          useValue: this.message
        },
        {
          provide: TOOLTIP_STATUS,
          useValue: this.tooltipStatus
        }
      ]
    );
  }

  protected hideTooltip(): void {
    if (this.tooltipOverlayRef == null) {
      return;
    }

    this.tooltipOverlayRef.destroy();
    this.tooltipOverlayRef = undefined;
  }
}
